import { useState, useEffect } from "react";
import ApplicationStep1 from "./ApplicationStep1";
// import ApplicationStep2 from "./ApplicationStep2";
import ApplicationStep3 from "./ApplicationStep3";
import ApplicationStep4 from "./ApplicationStep4";
import ApplicationStep5 from "./ApplicationStep5";
import ApplicationStep6 from "./ApplicationStep6";

const ApplicationFormV2 = () => {
  const [formStep, setFormStep] = useState(1);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [formStep]);

  return (
    <>
      {formStep === 1 && (
        <ApplicationStep1 currentStep={formStep} setCurrentStep={setFormStep} />
      )}

      {formStep === 2 && (
        <ApplicationStep3 currentStep={formStep} setCurrentStep={setFormStep} />
      )}

      {formStep === 3 && (
        <ApplicationStep4 currentStep={formStep} setCurrentStep={setFormStep} />
      )}

      {formStep === 4 && (
        <ApplicationStep5 currentStep={formStep} setCurrentStep={setFormStep} />
      )}

      {formStep === 5 && (
        <ApplicationStep6 currentStep={formStep} setCurrentStep={setFormStep} />
      )}
    </>
  );
};

export default ApplicationFormV2;
